import { useIntl } from '@weenat/wintl';
import { capitalize } from './utils';
export const useHandleDecitraitConnectErrorAndSuccess = ({ key, org, useToasts }) => {
    const { addToast } = useToasts();
    const { t } = useIntl();
    const onSuccess = () => {
        addToast(t('dss.decitrait.actions.connect_success', {
            org: org?.name
        }), {
            appearance: 'success',
            id: `decitrait-${key}-success`
        });
    };
    const onError = (e) => {
        /** This is for real */
        const [firstNonFieldError] = Array.isArray(e?.nonFieldErrors) ? e.nonFieldErrors : [];
        /** This is inslanely imparsable */
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const fieldError = e.fieldErrors?.error?.message?.message;
        if (fieldError) {
            addToast(
            /** Decitrait deliver ugly errors */
            capitalize(fieldError), {
                appearance: 'error',
                id: `decitrait-${key}-field-error`
            });
        }
        else if (firstNonFieldError)
            addToast(firstNonFieldError?.message, {
                appearance: 'error',
                id: `decitrait-${key}-non-field-error`
            });
        else {
            addToast(t('errors.unknown'), {
                appearance: 'error',
                id: `decitrait-${key}-unknown-error`
            });
        }
    };
    return {
        onError,
        onSuccess
    };
};
